import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { VertContainer, VertTypography, Col, Row } from '@vertem-core/vertice-ds';
import { FaGooglePlay, FaApple } from 'react-icons/fa';

import 'Assets/styles/default/components/LikePlus/LikePlusGeneric.less';

import Icon from 'components/Atoms/Icons/Icon';

import { managerAndroidApp, managerCustomCall, managerIOSApp, managerWebsite } from 'Constants/LikePlus';

const LikePlusManage = () => {
    const isLargeScreen = useMediaQuery({ minWidth: 769 });

    return (
        <VertContainer fluid={true} className={`like-plus-manage margin-y-big`} >
            <VertContainer className={`like-plus-contact col-12 ${!isLargeScreen ? 'margin-left-small' : ''}`}  >
                <Row gutter={0} align={`middle`}>
                    <Col className='col-12 margin-top-small'>
                        <Row gutter={0} align={`middle`}>
                            <Col className='col-12'>
                                <VertTypography.Paragraph type='default' className='txt-medium font-w-600 w-100 text-left'>
                                    Baixe o app
                                </VertTypography.Paragraph>
                            </Col>
                        </Row>
                    </Col>
                    <Col className='col-12'>
                        <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left margin-top-small'>
                            {managerCustomCall}
                        </VertTypography.Paragraph>
                        <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left'>
                            Você também pode acessar o site <a target="_blank" href={managerWebsite}>clicando aqui</a>.
                        </VertTypography.Paragraph>
                    </Col>
                    <Col className='col-12 margin-top-small'>
                        <Row gutter={24}>
                            {
                                managerAndroidApp && (
                                    <Col className='col-auto margin-top-small padding-x-small'>
                                        <Row gutter={0} align={`middle`}>
                                            <Col className='col-auto margin-right-extra-small'>
                                                <Icon className="download lucide color-neutral-dark" size={`24px`} component={FaGooglePlay} />
                                            </Col>
                                            <Col className='col'>
                                                <VertTypography.Paragraph type='default' className='txt-medium font-w-600 w-100 text-left'>
                                                    <a target="_blank" href={managerAndroidApp} className=' color-neutral-dark' style={{ color: 'var(--color-neutral-dark)' }}>Google Play</a>
                                                </VertTypography.Paragraph>
                                            </Col>
                                        </Row>
                                    </Col>
                                )
                            }

                            {
                                managerIOSApp && (
                                    <Col className='col-auto margin-top-small padding-x-small'>
                                        <Row gutter={0} align={`middle`}>
                                            <Col className='col-auto margin-right-extra-small'>
                                                <Icon className="download lucide color-neutral-dark" size={`24px`} component={FaApple} />
                                            </Col>
                                            <Col className='col'>
                                                <VertTypography.Paragraph type='default' className='txt-medium font-w-600 w-100 text-left'>
                                                    <a target="_blank" href={managerIOSApp} className='color-neutral-dark' style={{ color: 'var(--color-neutral-dark)' }}>App Store</a>
                                                </VertTypography.Paragraph>
                                            </Col>
                                        </Row>
                                    </Col>
                                )
                            }
                        </Row>
                    </Col>
                </Row>
            </VertContainer>
        </VertContainer>

    );
};

export default LikePlusManage;
